import React from 'react'

const IconNearby = ({ className }: { className: string }): JSX.Element => {
  return (
    <svg
      className={className}
      x="0px"
      y="0px"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="#clipRect">
        <path
          d="M10.5 10.5C12.9853 10.5 15 8.48528 15 6C15 3.51472 12.9853 1.5 10.5 1.5C8.01472 1.5 6 3.51472 6 6C6 8.48528 8.01472 10.5 10.5 10.5Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M11.5 14.555C11.172 14.519 10.838 14.5 10.5 14.5C5.529 14.5 1.5 18.529 1.5 23.5H15.5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
          strokeLinejoin="round"
        />
        <path
          d="M23.5 16.317C23.5 18.683 19.5 22.5 19.5 22.5C19.5 22.5 15.5 18.683 15.5 16.317C15.5 13.874 17.58 12.5 19.5 12.5C21.42 12.5 23.5 13.874 23.5 16.317Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M19.5 17.5C20.0523 17.5 20.5 17.0523 20.5 16.5C20.5 15.9477 20.0523 15.5 19.5 15.5C18.9477 15.5 18.5 15.9477 18.5 16.5C18.5 17.0523 18.9477 17.5 19.5 17.5Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clipRect">
          <rect
            width="24"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconNearby
